import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { EventTypes } from '@mc/track-event'
import { RegularFooter } from 'components/Footer/RegularFooter'
import EnterpriseNavigation from 'components/Navigation/enterprise/EnterpriseNavigation'
import { useSprig } from 'libs/sprig'
import { ForBusinessBody } from './components/ForBusinessBody'
import { Head } from './components/Head'
import { getPageLoadIntegrations } from './integrations'

const client = new QueryClient()

export const getServerSideProps = () => ({ props: {} })

const ForBusiness = () => {
  useSprig()

  return (
    <>
      <Head />
      <QueryClientProvider client={client}>
        <ForBusinessBody />
      </QueryClientProvider>
    </>
  )
}

ForBusiness.pageSettings = {
  title: 'MasterClass at Work',
  rumLabel: 'MAW Landing',
  analyticsLabel: EventTypes.ENTERPRISE_LANDING_PAGE,
  pageLoadIntegrations: getPageLoadIntegrations(true),
  navigation: EnterpriseNavigation,
  footer: RegularFooter,
}

export default ForBusiness
